var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col-12 l-m-b-20" }, [
        _c("div", { staticClass: "input-group search" }, [
          _c(
            "button",
            {
              staticClass: "btn input-group-btn",
              attrs: { type: "button" },
              on: { click: _vm.clearSearch }
            },
            [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.q,
                expression: "q"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Search" },
            domProps: { value: _vm.q },
            on: {
              keyup: function($event) {
                _vm.searchText($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.q = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.ratings.length
        ? [
            _c(
              "div",
              { staticClass: "ratings-wrap" },
              _vm._l(_vm.ratings, function(rating, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "row pr-0 flex flex-column single-rating"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-content-between pl-3 pt-2 pr-3"
                      },
                      [
                        rating.author
                          ? _c("span", { staticClass: "rating-author" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(rating.author.first_name) +
                                  " " +
                                  _vm._s(rating.author.last_name) +
                                  "\n          "
                              )
                            ])
                          : _c(
                              "span",
                              {
                                staticClass: "bg-danger text-white px-1 rounded"
                              },
                              [
                                _vm._v(
                                  "\n            Deleted customer\n          "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-column align-items-end" },
                          [
                            _c("span", { staticClass: "ref-id" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(rating.ref_id) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex pl-3 pr-3" }, [
                      _c("span", { staticClass: "rating-date-created pr-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(rating.date) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        { staticClass: "col-11 flex single-rating p-0" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-1 rating-grade-wrap p-0" },
                            [
                              _c("span", { staticClass: "rating-average" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(rating.rating) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-uppercase rating-subheading"
                                },
                                [
                                  _vm._v(
                                    "\n                out of 5\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4 flex star-ratings-wrapper" },
                            [
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-column" },
                                [
                                  _c("star-rating", {
                                    staticStyle: { "max-height": "16px" },
                                    attrs: {
                                      rating: rating.value,
                                      "star-size": 11,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("star-rating", {
                                    staticStyle: { "max-height": "16px" },
                                    attrs: {
                                      rating: rating.communication,
                                      "star-size": 11,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("star-rating", {
                                    staticStyle: { "max-height": "16px" },
                                    attrs: {
                                      rating: rating.punctuality,
                                      "star-size": 11,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("star-rating", {
                                    staticStyle: { "max-height": "16px" },
                                    attrs: {
                                      rating: rating.commitment,
                                      "star-size": 11,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("star-rating", {
                                    staticStyle: { "max-height": "16px" },
                                    attrs: {
                                      rating: rating.customer_service,
                                      "star-size": 11,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-7 row" },
                            [
                              _c(
                                "div",
                                { staticClass: "rating-grade-wrap col-6" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "customer-review text-break"
                                    },
                                    [
                                      rating.body
                                        ? _c("read-more", {
                                            attrs: {
                                              "more-str": "Show more",
                                              text: rating.body,
                                              "less-str": "Show less",
                                              "max-chars": 300
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              !rating.reply &&
                              !rating.reply_at &&
                              _vm.$_can("companies.ratings.update-reply")
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 flex justify-content-end align-items-start"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            on: {
                                              click: function($event) {
                                                _vm.ratingToReply = rating
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Reply to Customer Review\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "h5",
                                        { staticClass: "text-secondary" },
                                        [_vm._v("Company response:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "customer-review text-break"
                                        },
                                        [
                                          rating.reply
                                            ? _c("read-more", {
                                                attrs: {
                                                  "more-str": "Show more",
                                                  text: rating.reply,
                                                  "less-str": "Show less",
                                                  "max-chars": 300
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ]
                )
              })
            )
          ]
        : _vm.loading
          ? [
              _c(
                "vue-content-loading",
                { attrs: { width: 800, height: 450 } },
                _vm._l(15, function(x) {
                  return _c("rect", {
                    key: x,
                    attrs: {
                      x: "10",
                      y: 15 * x * 1.4,
                      rx: "5",
                      ry: "5",
                      width: "720",
                      height: "6"
                    }
                  })
                })
              )
            ]
          : [
              _c("span", { staticClass: "col-12 flex" }, [
                _vm._v("\n      No reviews\n    ")
              ])
            ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 flex" },
        [
          _vm.meta.total
            ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                _vm._v(
                  "\n      Showing " +
                    _vm._s(_vm.meta.from) +
                    " - " +
                    _vm._s(_vm.meta.to) +
                    " of " +
                    _vm._s(_vm.meta.total) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "col-sm-6 mb-1",
            attrs: { "change-page": _vm.changePage, meta: _vm.meta }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.ratingToReply
        ? _c("company-rating-reply-modal", {
            attrs: { rating: _vm.ratingToReply },
            on: { close: _vm.closeReply }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-column" }, [
      _c("span", { staticClass: "rating-name" }, [_vm._v("Service value")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-name" }, [_vm._v("Communication")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-name" }, [_vm._v("Punctuality")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-name" }, [_vm._v("Mover commitment")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-name" }, [_vm._v("Customer service")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47fa47a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47fa47a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ratings/CompanyRatingsList.vue
// module id = null
// module chunks = 